// extracted by mini-css-extract-plugin
export default {"flex":"WidgetEditDrawer_flex__Okokn","inputName":"WidgetEditDrawer_inputName__MaMGr","deleteButton":"WidgetEditDrawer_deleteButton__UWYxK","seeAll":"WidgetEditDrawer_seeAll__nSBEF"};